<template>
  <div id="naver-ad-container" v-if="processedAds && processedAds.length > 0">
    <naver-ad-header :searchQuery="searchQuery"
                     helpUrl="https://help.naver.com/service/5626/contents/1419?lang=ko"></naver-ad-header>
    <div class="naver_ad_content_wrapper">
      <div v-for="(ad, index) in processedAds" :key="index" class="box_naver_ad">
        <div class="naver_ad_content">
          <div class="cont_head">
            <div class="tit_wrap">
              <a :href="ad.clickUrl" class="profile_wrap" target="_blank" rel="noopener noreferrer">
                <img :src="ad.profileImgUrl" :class="['ico_profile', ad.profileClass]"
                     @error="handleImageError($event, '.profile_wrap')">
              </a>
              <a :href="ad.clickUrl" class="tit_headline" target="_blank" rel="noopener noreferrer">{{ ad.siteName || ad.headline }}</a>
              <a :href="ad.clickUrl" class="txt_url" target="_blank" rel="noopener noreferrer">{{ ad.cleanDisplayUrl }}</a>
            </div>
          </div>
          <div class="cont_body">
            <div class="cont_ad">
              <span class="tit_naver_ad"><a :href="ad.clickUrl" v-html="highlightKeyword(ad.headline || '')" target="_blank" rel="noopener noreferrer"></a></span>
              <p class="desc_naver_ad">
                <a :href="ad.clickUrl" target="_blank" rel="noopener noreferrer">
                  <span class="desc_text" v-html="highlightKeyword(ad.description || '')"></span>
                  <span class="medical_no" v-if="ad.medicalNo">{{ ad.medicalNo }}</span>
                </a>
              </p>
            </div>
            <div class="cont_img" v-if="ad.imageExtension">
              <a :href="ad.imageExtension.clickUrl" target="_blank" rel="noopener noreferrer">
                <img :src="ad.imageExtension.imageUrl" @error="handleImageError($event, '.cont_img')" alt=""
                     class="img_ad">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdCommonMixin from "./AdCommonMixin";
import NaverAdHeader from "./NaverAdHeader.vue";

export default {
  name: 'PowerLink',
  components: {
    NaverAdHeader
  },
  mixins: [AdCommonMixin],

  computed: {
    processedAds() {
      if (!this.ads) return null;

      return this.ads.map((ad) => {
        const profileInfo = this.getProfileInfo(ad);
        return {
          ...ad,
          profileImgUrl: profileInfo.profileImgUrl,
          profileClass: profileInfo.profileClass,
          cleanDisplayUrl: this.getCleanDisplayUrl(ad.displayUrl),
        };
      });
    }
  },

}
</script>